import { Directive, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { ApiService } from '../../../api/api.service';
import { isNil, isUndefined, find } from 'lodash-es';
import { NgxPicaErrorInterface, NgxPicaService } from '@digitalascetic/ngx-pica';
import { filter } from 'rxjs/operators';

declare var $: any;
@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[uploadImage]'
})
export class UploadFileDirective implements OnInit {
  // tslint:disable-next-line:no-input-rename
  @Input('accept')
  accept: string;
  // tslint:disable-next-line:no-input-rename
  @Input('uploadImage')
  uploadImage: any;
  // tslint:disable-next-line:no-input-rename
  @Input('inProgress')
  inProgress: any;
  // tslint:disable-next-line:no-input-rename
  @Input('subProgress')
  subProgress: any;
  // tslint:disable-next-line:no-input-rename
  @Input('subError')
  subError: any;
  // tslint:disable-next-line:no-input-rename
  @Input('allowMaxSize')
  allowMaxSize: any;

  @Input('allowMinSize')
  allowMinSize: any;

  // tslint:disable-next-line:no-input-rename
  @Input('allowMaxWidth')
  allowMaxWidth: any;

  // tslint:disable-next-line:no-input-rename
  @Input('allowMaxHeight')
  allowMaxHeight: any;

  // tslint:disable-next-line:no-input-rename
  @Input('allowMinWidth')
  allowMinWidth: any;

  // tslint:disable-next-line:no-input-rename
  @Input('allowMinHeight')
  allowMinHeight: any;

  // tslint:disable-next-line:no-input-rename
  @Input('type')
  type: any;
  // tslint:disable-next-line:no-input-rename
  @Input('uploadPath')
  uploadPath: any;
  // tslint:disable-next-line:no-input-rename
  @Input('parent_model')
  parent_model: any;
  // tslint:disable-next-line:no-input-rename
  @Input('model')
  model: any;
  // tslint:disable-next-line:no-input-rename
  @Input('multiple')
  multiple: any;

  @Input('rotatedEvent')
  rotatedEvent: any;

  @Input('isShowError')
  isShowError = true;

  @Input('imageUrl')
  imageUrl: string;

  valid_extensions;

  @Output('onComplete')
  onComplete = new EventEmitter();
  @Output('onError')
  onError = new EventEmitter();

  @Output('onRotated')
  onRotated = new EventEmitter();

  input;
  currentFile;

  constructor(private el: ElementRef, private api: ApiService, private ngxPicaService: NgxPicaService) {}

  ngOnInit() {
    if (!isUndefined(this.accept)) {
      this.valid_extensions = this.accept.split('|');
    }
    this.input = document.createElement('input');
    this.input.type = 'file';
    this.input.style.visibility = 'hidden';
    this.input.style.position = 'absolute';
    if (!isNil(this.multiple) && this.multiple === 'true') {
      this.input.multiple = true;
    }
    $(this.el.nativeElement).after(this.input);

    $(this.el.nativeElement).click((() => {
      if (this.inProgress[this.subProgress] !== true) {
        this.input.value = '';
        $(this.input).trigger('click');
      }
    }) as any);

    this.input.addEventListener('change', (event) => {
      this.addLoader();
      const files: Array<File> = Array.from(this.input.files);
      if (files.length > 0) {
        const isContainInValid = files.map((file) => this.validateFile(file)).find((s) => s === false) === false;
        if (!isContainInValid) {
          const merged = files.reduce((acc, file) => {
            const sizeInMb = this.bytesToMB(file.size);
            let size = Math.ceil(sizeInMb / 10);
            if (size > 1) {
              size = size * 2;
            } else {
              size = sizeInMb / 2;
            }
            if (!acc[size]) {
              acc[size] = [];
            }
            acc[size].push(file);
            return acc;
          }, {});
          for (const key in merged) {
            if (merged.hasOwnProperty(key)) {
              for (const mergedFile of merged[key]) {
                this.ngxPicaService
                  .compressImage(mergedFile, parseFloat(key), {
                    exifOptions: {
                      forceExifOrientation: false
                    }
                  })
                  .subscribe(
                    (imageResized: any) => {
                      this.uploadFile(imageResized, imageResized.name);
                    },
                    (err: NgxPicaErrorInterface) => {
                      this.uploadFile(mergedFile, mergedFile.name);
                    }
                  );
              }
            }
          }
        }
      }
      this.removeLoader();
    });

    if (this.rotatedEvent) {
      this.rotatedEvent.pipe(filter(() => !this.isInProgress())).subscribe(() => {
        this.rotate();
      });
    }
  }

  bytesToMB(bytes: number) {
    return bytes / 1048576;
  }

  isInProgress() {
    return this.inProgress[this.subProgress] === true;
  }

  addLoader() {
    this.inProgress[this.subProgress] = true;
    this.appendLoadingMessage();
  }

  removeLoader() {
    this.inProgress[this.subProgress] = false;
    this.removeLoadingMessage();
  }

  getFileExtension(file) {
    return file.name.split('.').pop();
  }

  appendLoadingMessage() {
    const loader = $(this.el.nativeElement).find('.loader');
    if (!loader.length) {
      $(this.el.nativeElement).prepend(`<p class="loader">Loading...</p>`);
    }
    loader.text('Loading...');
  }

  removeLoadingMessage() {
    const loader = $(this.el.nativeElement).find('.loader');
    $(loader).remove();
  }

  appendErrorMessage(msg) {
    this.onError.emit(msg);
    if (this.isShowError) {
      $(this.el.nativeElement).addClass('ng-invalid');
      const label = $(this.el.nativeElement).find('label');
      if (!label.length) {
        $(this.el.nativeElement).prepend(`<label>${msg}</label>`);
      }
      label.text(msg);
    }
  }

  removeErrorMessage() {
    if (this.isShowError) {
      $(this.el.nativeElement).removeClass('ng-invalid');
      const label = $(this.el.nativeElement).find('label');
      if (label.length) {
        label.text('');
      }
    }
  }

  uploadFile(blob, name) {
    this.removeErrorMessage();
    this.upload(blob, name);
  }

  validateFile(file) {
    if (!file) {
      return false;
    }
    if (!isNil(this.allowMinSize) && this.allowMinSize !== '') {
      if (file.size < parseFloat(this.allowMinSize) * 1024) {
        this.appendErrorMessage('File size too small');
        return false;
      }
    }
    if (!isNil(this.allowMaxSize) && this.allowMaxSize !== '') {
      if (file.size > parseFloat(this.allowMaxSize) * 1000000) {
        this.appendErrorMessage('File size too big');
        return false;
      }
    }
    if (!isUndefined(this.accept) && isUndefined(find(this.valid_extensions, (item) => item.toLowerCase() === this.getFileExtension(file).toLowerCase()))) {
      this.appendErrorMessage('Invalid file type');
      return false;
    }
    if (!isUndefined(this.allowMaxWidth) || !isUndefined(this.allowMaxHeight)) {
      const sizes = this.checkDimension(file);
      if ((sizes as any).width > parseFloat(this.allowMaxWidth) || (sizes as any).height > parseFloat(this.allowMaxHeight)) {
        this.appendErrorMessage('Invalid image dimensions: max size ' + this.allowMaxWidth + ' x ' + this.allowMaxHeight);
        return false;
      }
    }
    if (!isUndefined(this.allowMinWidth) || !isUndefined(this.allowMinHeight)) {
      const sizes = this.checkDimension(file);
      if ((sizes as any).width < parseFloat(this.allowMinWidth) || (sizes as any).height < parseFloat(this.allowMinHeight)) {
        this.appendErrorMessage('Invalid image dimensions: min size ' + this.allowMinWidth + ' x ' + this.allowMinHeight);
        return false;
      }
    }
    return true;
  }

  checkDimension(file) {
    const _URL = window.URL;
    // tslint:disable-next-line:only-arrow-functions
    return new Promise(function (resolve, reject) {
      const img = new Image();
      img.src = _URL.createObjectURL(file);
      img.onload = function () {
        const sizes = {
          width: 0,
          height: 0
        };
        sizes.width = (this as any).width;
        sizes.height = (this as any).height;
        resolve(sizes);
      };
    });
  }

  upload(file, name) {
    this.inProgress[this.subError] = false;
    this.api.file.upload(file, name).subscribe(
      (response) => {
        this.currentFile = file;
        this.removeLoader();
        this.bindingData(response);
      },
      (error) => {
        this.removeLoader();
        this.inProgress[this.subError] = true;
        if (this.onError.observers.length) {
          this.appendErrorMessage(error.message);
        }
      }
    );
  }

  rotate() {
    this.addLoader();
    const file = this.currentFile;
    // if image is being uploaded/new image it will rotate on frontend, if existing image it will call api rotate
    // if (file) {
    //   new Promise((resolve, reject) => {
    //     try {
    //       const img = new Image();
    //       const reader: FileReader = new FileReader();
    //       reader.addEventListener('load', (event: any) => {
    //         img.onload = () => {
    //           const canvas: HTMLCanvasElement = document.createElement('canvas');
    //           const ctx = canvas.getContext('2d');
    //           canvas.width = img.height;
    //           canvas.height = img.width;

    //           ctx.rotate((1 / 2) * Math.PI);
    //           ctx.drawImage(img, 0, -img.height);
    //           const Pica = require('pica');
    //           const picaResizer = new Pica();
    //           picaResizer.toBlob(canvas, file.type).then(
    //             (blob) => {
    //               const newFile: File = Object.assign(
    //                 new Blob([blob], {
    //                   type: file.type
    //                 })
    //               );
    //               resolve(newFile);
    //             },
    //             (e) => {
    //               throw e;
    //             }
    //           );
    //         };
    //         img.src = String(reader.result);
    //       });
    //       reader.readAsDataURL(file);
    //     } catch (e) {
    //       reject(e);
    //     }
    //   }).then((rotatedFile: File) => this.upload(rotatedFile, rotatedFile.name));
    // } else {
    //   const imageUrl = this.imageUrl;
    //   this.api.file
    //     .rotate(imageUrl)
    //     .toPromise()
    //     .then((s) => {
    //       this.onRotated.emit(s);
    //       this.removeLoader();
    //     });
    // }
  }

  bindingData(response) {
    if (this.onComplete.observers.length) {
      this.onComplete.emit(response);
      this.removeErrorMessage();
    }
  }
}
